/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import _ from 'lodash';
import Select from 'react-select';
import queryString from 'query-string';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import Pagination from 'modules/common/components/Pagination';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Drawer from '@material-ui/core/Drawer';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import history from '../../../../history';
import ExportAuditLogModal from '../components/ExportAuditLogModal';
import * as actions from '../actions';
import * as c from '../constants';

const styles = () => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '400px',
  },
});

const INIT_STATE = {
  date_from: moment().startOf('month').format('YYYY-MM-DD'),
  date_to: moment().endOf('month').format('YYYY-MM-DD'),
  type: 'GENERAL',
};

const AuditLogReport = ({
  getComputerFeeList,
  list,
  isLoading,
  pager,
  permissions,
  classes,
  getReportAccess,
}) => {
  
  const location = useLocation();
  const { payload } = location.state || {};

  if (payload) {
    INIT_STATE.type = payload.module;
  }

  //   const token = get('token') || '';
  //   const authProfile = getJson('profile') || {};
  const [formData, setFormData] = useState(INIT_STATE);
  const [showSide, setShowSide] = useState(false);

  useEffect(() => {
    getComputerFeeList(formData);
  }, []);

  const syncFilters = (params) => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: moment(new Date(value)).format('YYYY-MM-DD'),
      });
    };

  const handleChangePage = (page) => {
    getComputerFeeList({ ...formData, page });
    syncFilters({ ...formData, page });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getComputerFeeList(formData);
  };

  const handleExportHistory = () => (e) => {
    e.preventDefault();
    setShowSide(!showSide);
  };

  const handleClose = () => {
    setShowSide(false);
  };

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: _.get(e, 'value', '') || '',
    });
  };

  return (
    <div className="">
      ,
      <form
        onSubmit={handleSearch}
        style={{ padding: '7px', marginBottom: '10px' }}
      >
        <div className="d-flex">
          <div className="form-input-group ml-2">
            <label className="label-reports uppercase">Date From</label>
            <DateInputPicker
              className="full-input"
              style={{ height: '36px' }}
              onChange={handleDateChange('date_from')}
              value={moment(new Date(_.get(formData, 'date_from'))).format(
                'MM/DD/YYYY'
              )}
              maxDate={new Date(_.get(formData, 'date_to'))}
              endDate={new Date(_.get(formData, 'date_to'))}
            />
          </div>
          <div className="form-input-group ml-2">
            <label className="label-reports uppercase">Date To</label>
            <DateInputPicker
              className="full-input"
              style={{ height: '36px' }}
              onChange={handleDateChange('date_to')}
              value={moment(new Date(_.get(formData, 'date_to'))).format(
                'MM/DD/YYYY'
              )}
              minDate={new Date(_.get(formData, 'date_from'))}
            />
          </div>
          <div className="form-input-group ml-2" style={{ width: '220px' }}>
            <label className="label-reports">Module Type</label>
            <Select
              isClearable
              name="type"
              placeholder="Select Type"
              onChange={handleChangeSelect('type')}
              options={c.MODULE_TYPE_LIST}
              value={
                c.MODULE_TYPE_LIST.find(
                  (option) => option.value === formData.type
                ) || null
              }
            />
          </div>
          <div className="form-input-group ml-2" style={{ marginTop: '2px' }}>
            <div className="full-input">
              <button
                disabled={
                  _.isEmpty(_.get(formData, 'date_from')) ||
                  _.isEmpty(_.get(formData, 'date_to')) ||
                  isLoading
                }
                type="submit"
                className="btn btn-primary cms-bg-color-primary text-white button-distribution-report mr-2"
              >
                <i className="fas fa-search" /> &nbsp;&nbsp;Search
              </button>
            </div>
          </div>
          <div className="form-input-group" style={{ marginTop: '2px' }}>
            <div className="full-input">
              <button
                disabled={
                  _.isEmpty(_.get(formData, 'date_from')) ||
                  _.isEmpty(_.get(formData, 'date_to')) ||
                  isLoading
                }
                type="submit"
                className="btn btn-primary cms-bg-color-primary text-white button-distribution-report mr-2"
              >
                Refresh
              </button>
            </div>
          </div>
          {/* <div className="form-input-group ml-auto">
            <div className="full-input">
              <button
                onClick={handleExportHistory()}
                className="btn btn-primary cms-bg-color-primary font-weight-bold button-distribution-report"
                type="button"
              >
                <i className="fas fa-download mr-2" /> Export
              </button>
            </div>
          </div> */}
        </div>
      </form>
      <AudigLogContent isLoading={isLoading} list={list} getReportAccess={getReportAccess} />
      <div className="list-pagination">
        {pager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={pager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
        )}
      </div>
      <Drawer
        PaperProps={{ classes: { root: classes.dialogPaper } }}
        anchor="right"
        open={showSide}
        onClose={handleClose}
        style={{ width: '100%', maxWidth: '400px' }}
      >
        <ExportAuditLogModal handleClose={handleClose} prevFilter={formData} />
      </Drawer>
    </div>
  );
};

AuditLogReport.propTypes = {
  getComputerFeeList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  //   permissions: PropTypes.instanceOf(Object).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  list: _.get(api, `${c.COMPUTER_FEE_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.COMPUTER_FEE_LIST) > -1,
  pager: _.get(api, `${c.COMPUTER_FEE_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default withStyles(styles)(enhance(AuditLogReport));

const AudigLogContent = ({ isLoading, list, getReportAccess }) => {
  const [permissions, setPermissions] = useState([]);
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    setPermissions(getJson('permissions'));
  }, []);
  
  const handleDownload = (id) => (e) => {
    e.preventDefault();
    const reportAccessArgs = {
      path: `/api/v1/administrators/report_file_exports_download/${id}`,
      query: {
        email: _.get(authProfile, 'email'),
        output: 'D',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  if (isLoading) {
    return (
      <div
        className="loading d-flex text-center justify-content-center align-items-center"
        style={{ height: '500px' }}
      >
        <div className="spinner text-center ">
          <span className="fas fa-5x fa-spin fa-spinner" />
        </div>
      </div>
    );
  }

  if (_.isEmpty(list)) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <div className="text-center mx-auto py-4">
          <img
            src={emptyStateImage}
            className="img-responsive image-wrapper mb-4 mt-3"
            alt="Empty State"
          />
          <p className="emp-title mb-0">No Item Found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-sm table-bordered table-hover">
        <thead className="table-header">
          <tr className="billing-table-tr">
            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
              DATE AND TIME
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
              FILE NAME
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
              MODULE TYPE
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
              FILE PATH
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
              SIZE (kb)
            </th>
            <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
              STATUS
            </th>
            {Acl(permissions, ['DOWNLOAD EXPORTS AUDITS']) && (
              <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                ACTION
              </th>
            )}
          </tr>
        </thead>
        <tbody className="table-details">
          {list.map((item) => {
            return (
              <tr key={item.id}>
                <td className="truncate">
                  {_.get(item, 'attributes.date_exported') || '---'}
                </td>
                <td className="truncate">
                  {_.get(item, 'attributes.file_name') || '---'}
                </td>
                <td className="truncate">
                  {_.get(item, 'attributes.report_type') || '---'}
                </td>
                <td className="truncate">
                  {_.get(item, 'attributes.file_path') || '---'}
                </td>
                <td className="truncate">
                  {_.get(item, 'attributes.size') || '---'}
                </td>
                <td className="text-xs h-100">
                  <div className="h-100 d-flex align-items-center justify-content-center">
                    <span
                      className={`px-3 py-1 text-white rounded-pill ${
                        _.get(item, 'attributes.status') ===
                        'FINISHED EXPORTING'
                          ? 'bg-primary'
                          : 'bg-danger'
                      }`}
                    >
                      <small>{_.get(item, 'attributes.status') || '---'}</small>
                    </span>
                  </div>
                </td>
                {Acl(permissions, ['DOWNLOAD EXPORTS AUDITS']) && (
                  <td className="h-100">
                    <div className="d-flex align-items-center justify-content-end">
                      {_.get(item, 'attributes.status') ===
                        'FINISHED EXPORTING' && (
                        <a
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                          href="#/"
                          onClick={handleDownload(item.id)}
                          rel="noopener noreferrer"
                        >
                          <i className="fas fa-folder-open mr-2" /> Download
                        </a>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

AudigLogContent.propTypes = {
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};
